/**
 * The form editor for hosts every org uses (form page, My Forms, household
 * forms, outreach tracking): the TRUS-762 restyled editor for an org on
 * `member_profile_v2`, the previous one otherwise (TRUS-762 rollout).
 */
import { FormInstanceEditor as FormInstanceEditorV2 } from './FormInstanceEditor';
import { FormInstanceEditor as FormInstanceEditorLegacy } from './FormInstanceEditorLegacy';
import { withMemberProfileV2 } from '@/components/members/memberProfileRollout';

export const FormInstanceEditor = withMemberProfileV2<any>(FormInstanceEditorV2, FormInstanceEditorLegacy, 'FormInstanceEditor');

export default FormInstanceEditor;
